import React from 'react'
import NumberAnimation from '../../_library/NumberAnimation'
import ReactTransitions from 'react-transitions'

export default class InfluencerShareRate extends React.Component {
  render() {
    const { statistics, isLoading } = this.props

    let rate = 0
    let total_impressions = 0
    let imgUser = 'user_cooler'
    if (statistics) {
      rate = !!statistics.share_rate ? parseInt(statistics.share_rate) : 0
      total_impressions = !!statistics.total_impressions
        ? parseInt(statistics.total_impressions[0].impressions)
        : 0
      if (rate < 20) imgUser = 'user_cooler'
      else if (rate < 40) imgUser = 'user_orange'
      else if (rate < 50) imgUser = 'user_red'
      else imgUser = 'user_hot'
    }

    return (
      <div className="influencers-shareRate">
        <div className="shareRate_background">
          <div className="worldmap">
            <div className="result_img">
              <div className="shareRate_user">
                <ReactTransitions transition="scale-down-center-scale-up-center" width={300} height={120}>
                  <img
                    alt="no-data"
                    ref="shareRate_user"
                    key={`shareRate_user${imgUser}`}
                    src={asset('/resources/images/event/influencers/sharerate/' + imgUser + '.png')}
                  />
                </ReactTransitions>
              </div>
              <div className="shareRate_engagement">
                <div>INFLUENCER ENGAGEMENT</div>
              </div>
            </div>
            <div className="result_value">
              <div className="shareRate">
                <div className="shareRate_percentage">
                  <div className="percentage">
                    <NumberAnimation isLoading={isLoading} target={rate} subfix={'%'} linear={false} />
                  </div>
                </div>
              </div>
              <div className="shareRate_current">
                <div className={'inner_text ' + imgUser}>
                  <i className="fa fa-circle-o" />
                  &nbsp;CURRENT SHARE RATE
                </div>
              </div>
            </div>
            <div className="result_impression">
              <div className="value">
                <NumberAnimation
                  duration={4000}
                  localeString={true}
                  isLoading={isLoading}
                  target={total_impressions}
                  linear={false}
                />
              </div>
              <div className="title">
                <div className={'inner_text ' + imgUser}>
                  LINK CLICKS GENERATED BY
                  <br />
                  REFERRAL SHARES
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
